// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-theme="blue"] {
    --primary: #58A5F8;
    &[data-mode="dark"] {
        --background: #1A222C;
        --color: #B5C3D3;
        --bar-background: #24303F;
        --bar-color: #898A8A;
        --border-color: #24303F; 
        --active-border-color: #656973;
        --hover-background: #3a4452;
        --selected-background: #212b38;
        --selected-color: #d7dae0;
        --drop-background: #142E48;
    }
    &[data-mode="light"] {
        --highlight: #112131;
        --background: #dfe8f2;
        --color: #040404; 
        --bar-background: #5F90C2;
        --bar-color: #676D75;
        --border-color: #4480C7;
        --active-border-color: #5F90C2;
        --hover-background: #bed2e6;
        --selected-background: #a4c0dc;
        --selected-color: #15181c;
        --drop-background: #b8c0c8;
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
